import { Station } from '../../types';
import { getEffectivePopulation } from '../../utils/population';

export function getSortedStationIndices(stations: Station[]): number[] {
  return stations
    .map((_, i) => i)
    .sort((a, b) => {
      const popA = getEffectivePopulation(stations[a]);
      const popB = getEffectivePopulation(stations[b]);
      if (popB !== popA) {
        return popB - popA;
      }
      return (stations[a].name || '').localeCompare(stations[b].name || '');
    });
}

export function getSortedStations(stations: Station[]): Station[] {
  const sortedIndices = getSortedStationIndices(stations);
  return sortedIndices.map(i => stations[i]);
}

export function reorderMatrix(matrix: number[][], sortedIndices: number[]): number[][] {
  // Validate inputs
  if (!matrix || !Array.isArray(matrix) || matrix.length === 0 || !sortedIndices || !Array.isArray(sortedIndices)) {
    return [];
  }
  // Validate matrix structure
  const isValidMatrix = matrix.every(row => Array.isArray(row) && row.length === matrix.length);
  if (!isValidMatrix) {
    return [];
  }
  // Validate indices
  const isValidIndices = sortedIndices.every(i => typeof i === 'number' && i >= 0 && i < matrix.length);
  if (!isValidIndices) {
    return [];
  }
  return sortedIndices.map(i => 
    sortedIndices.map(j => matrix[i][j])
  );
}

export function reorderStationsAndMatrix(stations: Station[], matrix: number[][]): {
  stations: Station[];
  matrix: number[][];
} {
  const sortedIndices = getSortedStationIndices(stations);
  return {
    stations: sortedIndices.map(i => stations[i]),
    matrix: reorderMatrix(matrix, sortedIndices)
  };
} 